/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Textarea } from 'baseui/textarea';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { mergeOverrides } from 'baseui';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const {
		clearable = false,
		required = false,
		error = false,
		positive = false,
		disabled = false,
		overrides,
		size = 'default',
		...rest
	} = props;

	return (
		<Textarea
			ref={ref}
			clearable={clearable}
			required={required}
			error={error}
			positive={positive}
			size={size}
			{...rest}
			overrides={
				overrides
					? mergeOverrides(customOverrides(props, disabled), overrides as any)
					: customOverrides(props, disabled)
			}
		/>
	);
});
